/**鎿嶄綔绗�-浼樺厛绾ц〃*/
var OPN_TABLE = 
{
	'+' : 0,
	'-' : 0,
	'*' : 1,
	'/' : 1,
	'^' : 2,
};

/**鍑芥暟鏌ヨ琛�*/
var FUNC_TABLE = 
{
	'sin' : 1,
	'cos' : 1,
	'tan' : 1,
	'cot' : 1,
	'arcsin' : 1,
	'arccos' : 1,
	'arctan' : 1,
	'ln' : 1,
	'log' : 1,
};

/**妫€鏌ユ槸鍚︿负鏁板瓧*/
var isNumber = function(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

/**浜屽弶琛ㄨ揪鏍�*/
function ExpTree(key) {
	//鏍硅妭鐐�
	this.root = null;
	//鏈煡閲忕殑琛ㄨ揪褰㈠紡锛岄粯璁や负x
	this.key = key || 'x';
	//涓簭閬嶅巻鐨勫瓧绗︿覆
	this.infix = '';
	//鍚庣画閬嶅巻鐨勫瓧绗︿覆
	this.postfix = '';
}

/**浜屽弶琛ㄨ揪鏍戣妭鐐�*/
function ExpTreeNode(key, left, right) {
	//鑺傜偣鍊�
	this.key = key;
	//宸﹀瓙鏍戯紝榛樿涓虹┖
	this.left = left || null;
	//鍙冲瓙鏍戯紝榛樿涓虹┖
	this.right = right || null;
}

/**棰勫鐞嗚〃杈惧紡瀛椾覆*/
ExpTree.prototype.preHandleExp = function(exp) {
	if(!exp) return '';
	//琛ュ叏灏忔暟鐐圭殑鍓嶇紑0
	exp = exp.replace(/([^0-9]|^)(\.\d+)/g, '$10$2');
	//澶勭悊鐪佺暐涔樺彿鐨勬儏鍐�
	var reg2 = new RegExp('([0-9]+(?:[.][0-9]*)?|.[0-9]+)(['+this.key+' e pi])', 'g');
	exp = exp.replace( reg2,  '$1*$2');
	//澶勭悊鍗曠洰杩愮畻绗� '+' '-'
	var c1 = '+', c2;
	var addRp = false;
	for (var i = 0; i < exp.length; ++i) {
		c2 = exp[i];
		if(c2 in OPN_TABLE && addRp) {
			addRp = false;
			exp = exp.slice(0,i) + ')' + exp.slice(i);
			++ i;
		}
		if((c1 in OPN_TABLE || c1 == '(' || c1 == ',') && c2 in OPN_TABLE) {
			if(c2 == '+') {
				//娓呴櫎澶氫綑鐨�+
				exp = exp.slice(0,i) + exp.slice(i+1);
				-- i;
			}
			else if(c2 == '-') {
				//鍦ㄥ墠闈㈡坊鍔�'(0'
				exp = exp.slice(0,i) + '(0' + exp.slice(i);
				i += 2;
				//缃负闇€瑕佹坊鍔�')'妯″紡
				addRp = true;
			}
		}
		c1 = c2;
	}
	if(addRp) {
		exp += ')';
	}
	return exp;
};

/**涓紑琛ㄨ揪寮忚浆鍚庣紑琛ㄨ揪寮� 璋冨害鍦虹畻娉�*/
ExpTree.prototype.inFixToPostFix = function(exp) {
	var postFix = [];
	var stack = [];
	//璋冨害鍦虹畻娉�
	exp = this.preHandleExp(exp);
	var c, o1, o2, sign;
	var func = '';
	for (var i = 0; i < exp.length; ++i) {
		c = exp[i];
		//鏁板瓧
		if(c >= '0' && c <= '9') {
			sign = false;
			while(i < exp.length && (exp[i] == '.' || (exp[i] >= '0' && exp[i] <= '9'))) {
				++ i;
				c += exp[i];
				sign = true;
			}
			if(sign) {
				-- i;
			}
			//try catch here
			try {
				postFix.push(parseFloat(c));
			}catch(error) {
				return '';
			}
		}
		//鐗规畩瀛楃 e x
		else if(c == 'e' || c == 'x') {
			postFix.push(c);	
		}
		//鍑芥暟鍒嗛殧绗�
		else if(c == ',') {
			while(stack.length && stack[stack.length-1] != '(') {
				postFix.push(stack.pop());
			}
		}
		//杩愮畻绗�
		else if(c in OPN_TABLE) {
			o1 = c;
			if(stack.length) {
				o2 = stack[stack.length-1];
				while(o2 in OPN_TABLE && OPN_TABLE[o2] - OPN_TABLE[o1] >= 0) {
					postFix.push(stack.pop());
					if(!stack.length) {
						break;
					}
					o2 = stack[stack.length-1];
				}
			}
			stack.push(o1);
		}
		//宸︽嫭鍙�
		else if(c == '(') {
			stack.push(c);
		}
		//鍙虫嫭鍙�
		else if(c == ')') {
			while(stack.length && stack[stack.length-1] != '(') {
				postFix.push(stack.pop());
			}
			if(!stack.length) {
				return '';
			}
			if(stack.length && stack[stack.length-1] == '('){
				stack.pop();
				if(stack.length && stack[stack.length-1] in FUNC_TABLE) {
					postFix.push(stack.pop());
				}
			}
		}
		//鍑芥暟绗�
		else {
			func += c;
			if(func in FUNC_TABLE) {
				stack.push(func);
				func = '';
			}
		}

	}
	if(stack.length) {
		if(stack[stack.length-1] == '(' || stack[stack.length-1] == ')' ) {
			return '';
		}
		else {
			while(stack.length) {
				postFix.push(stack.pop());
			}
		}
	}
	if(func) {
		return '';
	}

	return postFix;
}

/**鏋勫缓浜屽弶琛ㄨ揪鏍�*/
ExpTree.prototype.build = function(infixExp) {
	var exp = infixExp.toLowerCase();
	exp = exp.replace( /\s/g, "" );
	var postFix = this.inFixToPostFix(exp);
	if(postFix == '') {
		return false;
	}
	var stack = [];
	var c, n;
	for (var i = 0; i < postFix.length; i++) {
		c = postFix[i];
		if(isNumber(c) || c == 'e' || c == 'pi' || c == 'x') {
			stack.push(new ExpTreeNode(c));
		}
		else {
			if(c == '(' || c == ')') {
				return false;
			}
			n = new ExpTreeNode(c);
			n.right = stack.pop();
			if(c in OPN_TABLE || c == 'log') {
				n.left = stack.pop();
				if(!n.left) {
					return false;
				}
			}
			stack.push(n);
		}
	}
	this.root = stack[0];
	if(!this.root.left && !this.root.right) {
		return false;
	}
	return stack.length <= 1;
}

ExpTree.prototype._toInFix = function(node) {
	if(node) {
		this._toInFix(node.left);
		this.infix += node.key;
		this._toInFix(node.right);
	}
};

ExpTree.prototype.toInFix = function() {
	this.infix = '';
	this._toInFix(this.root);
	return this.infix;
};

ExpTree.prototype._toPostFix = function(node) {
	if(node) {
		this._toPostFix(node.left);
		this._toPostFix(node.right);
		this.postfix += node.key;
	}
};

ExpTree.prototype.toPostFix = function() {
	this.postfix = '';
	this._toPostFix(this.root);
	return this.postfix;
};

/**鎵ц鍘熷瓙璁＄畻*/
ExpTree.prototype.op = function(opr, left, right) {
	switch(opr) {
		case '+':
			return left + right;
		case '-':
			return left - right;
		case '*':
			if(left == 0 || right == 0) {
				return 0;
			}
			return left * right;
		case '/':
			return left / right;
		case '^':
			return Math.pow(left, right);
		case 'sin':
			return Math.sin(right);
		case 'cos':
			return Math.cos(right);
		case 'tan':
			return Math.tan(right);
		case 'cot':
			return 1 / Math.tan(right);
		case 'arcsin':
			return Math.asin(right);
		case 'arccos':
			return Math.acos(right);
		case 'arctan':
			return Math.atan(right);
		case 'ln':
			return Math.log(right);
		case 'log':
			return Math.log(right) / Math.log(left);
		default:
			//error!
			// console.log(opr, 'error!');
			return 0;
	}
};

/**鏄惁鍚湭鐭ラ噺*/
ExpTreeNode.prototype._containParam = function(node) {
	if(node){
		if(node.key == this.key) {
			return true;
		}
		else {
			return this._containParam(node.left) || this._containParam(node.right);
		}
	}
	return false;
};

/**閫掑綊璁＄畻琛ㄨ揪寮忕殑鍊�*/
ExpTree.prototype.cal = function(node, x) {
	if(!node) {
		return;
	}
	if(node.left || node.right) {
		return this.op( node.key, this.cal(node.left, x), this.cal(node.right, x) );
	}
	switch(node.key) {
		case 'x':
			return x;
		case 'e':
			return Math.E;
		case 'pi':
			return Math.PI;
		default:
			return node.key;
	}
};

/**姹傚鍑芥暟鏍�*/
ExpTree.prototype.dao = function(node) {
	if(!node) {
		return;
	}
	var t;
	switch(node.key) {
		case '+':
		case '-':
			//(l+r)' = l' + r'
			//(l-r)' = l' - r'
			t = new ExpTreeNode(node.key, this.dao(node.left), this.dao(node.right));
			break;
		case '*':
			//(l*r)' = l'*r + l*r'
			t = new ExpTreeNode('+');
			t.left = new ExpTreeNode('*', this.dao(node.left), node.right);
			t.right = new ExpTreeNode('*', node.left, this.dao(node.right));
			break;
		case '/':
			//(l/r)' = (l'*r - l*r') / (r*r)
			t = new ExpTreeNode('/');
			t.left = new ExpTreeNode('-');
			t.left.left = new ExpTreeNode('*', this.dao(node.left), node.right);
			t.left.right = new ExpTreeNode('*', node.left, this.dao(node.right));
			t.right = new ExpTreeNode('*', node.right, node.right);
			break;
		case '^':
			t = new ExpTreeNode('*');
			if(node.right._containParam(node.right)) {
				//(l^r)' = (l^r) * (ln(l)*r)'
				t.left = node;
				t.right = this.dao(new ExpTreeNode('*', new ExpTreeNode('ln', null, node.left), node.right));
			}
			else {
				//(l^c)' = (l'*c) * l^(c-1)
				t.left = new ExpTreeNode('*', this.dao(node.left), node.right);
				t.right = new ExpTreeNode('^', node.left, new ExpTreeNode('-', node.right, new ExpTreeNode(1)));
			}
			break;
		case 'sin':
			//sin(r)' = cos(r)*r'
			t = new ExpTreeNode('*');
			t.left = new ExpTreeNode('cos', null, node.right);
			t.right = this.dao(node.right);
			break;
		case 'cos':
			//cos(r)' = 0-sin(r)*r'
			t = new ExpTreeNode('-', new ExpTreeNode(0));
			t.right = new ExpTreeNode('*', new ExpTreeNode('sin', null, node.right), this.dao(node.right));
			break;
		case 'tan':
			//tan(r)' = r' / (cos(r) * cos(r))
			t = new ExpTreeNode('/', this.dao(node.right));
			t.right = new ExpTreeNode('*', new ExpTreeNode('cos', null, node.right), new ExpTreeNode('cos', null, node.right));
			break;
		case 'cot':
			//cot(r)' = 0-r'/(sin(r)*sin(r))
			t = new ExpTreeNode('-', new ExpTreeNode(0));
			t.right = new ExpTreeNode('/', this.dao(node.right));
			t.right.right = new ExpTreeNode('*', new ExpTreeNode('sin', null, node.right), new ExpTreeNode('sin', null, node.right));
			break;
		case 'arcsin':
			//arcsin(r)' = r' / (1-r*r)^0.5
			t = new ExpTreeNode('/', this.dao(node.right))
			t.right = new ExpTreeNode('^', null, new ExpTreeNode(0.5));
			t.right.left = new ExpTreeNode('-', new ExpTreeNode(1), new ExpTreeNode('*', node.right, node.right));
			break;
		case 'arccos':
			t = new ExpTreeNode('/', this.dao(node.right))
			t.right = new ExpTreeNode('^', null, new ExpTreeNode(0.5));
			t.right.left = new ExpTreeNode('-', new ExpTreeNode(1), new ExpTreeNode('*', node.right, node.right));
			t = new ExpTreeNode('-', new ExpTreeNode(0), t);
			//arccos(r)' = 0 - (r' / (1-r*r)^0.5)
			break;
		case 'arctan':
			t = new ExpTreeNode('/', this.dao(node.right))
			t.right = new ExpTreeNode('+', new ExpTreeNode(1), new ExpTreeNode('*', node.right, node.right));
			//arcsin(r)' = r' / (1+r*r)
			break;
		case 'ln':
			//ln(r)' = r'/r
			t = new ExpTreeNode('/', this.dao(node.right), node.right);
			break;
		case 'log':
			//log(l,r) = r'/(r*ln(l))
			t = new ExpTreeNode('/', this.dao(node.right));
			t.right = new ExpTreeNode('*', node.right, new ExpTreeNode('ln', null, node.left));
			break;
		case 'x':
			//x' = 1
			t = new ExpTreeNode(1);
			break;
		default:
			//甯搁噺鐨勫鏁颁负0
			t = new ExpTreeNode(0);
			break;
	}
	return t;
};

// function cal_exp(exp) {
//     var t = new ExpTree();
//     t.build(exp);
//     var dtn = t.dao(t.root);
//     var dt = new ExpTree();
//     dt.root = dtn;
//     var x0 = 1,
//         x1 = 2,
//         i = 0;
//     while (Math.abs(x0 - x1) > 10E-9) {
//         x0 = x1;
//         x1 = x0 - (t.cal(t.root, x0) / dt.cal(dt.root, x0));
//         ++i;
//         if (i > 10E6) {
//             break;
//         }
//     }
//     if (Math.abs(x1 - Math.round(x1)) < 10E-8) {
//         x1 = Math.round(x1);
//     }
//     if (isNaN(x1)) {
//        console.log('鏃犺В鎴栫墰椤挎硶瀵规涓嶆敹鏁涖€�');
//     }
//     else {
//     	console.log('x = ',x1);
//     }
//     return x1;
// }


// cal('5x^4-9x^2+9');
export default ExpTree;